import { render } from "./school.vue?vue&type=template&id=15346009"
const script = {}

import "./school.vue?vue&type=style&index=0&id=15346009&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__